import { render, staticRenderFns } from "./syncAMISPopup.vue?vue&type=template&id=3045a880"
import script from "./syncAMISPopup.vue?vue&type=script&lang=js"
export * from "./syncAMISPopup.vue?vue&type=script&lang=js"
import style0 from "./syncAMISPopup.vue?vue&type=style&index=0&id=3045a880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports